import React from "react";
import { connect } from "react-redux";
import LoadingSpinner from "@js/components/studio/utilities/loading_spinner.jsx";
import { humanReadableSize } from "@js/helpers/text_format.js";
import { ceModalUploadAttachmentOpen } from "@js/actions/studio/campaign_content_section/modal_upload_attachment.js";
import { ceModalRemoveAttachmentShow } from "@js/actions/studio/campaign_content_section/modal_remove_attachment.js";

const AttachmentsSection = (props) => {
  let attachmentLoadingSpinner = (
    <LoadingSpinner width="6%" height="50px" marginX="47%" />
  );

  return props.attachments && props.attachments.length > 0 ? (
    <div className="attachments-container">
      <table className="data-table">
        <thead>
          <tr className="active">
            <th>
              {t("simple_form.labels.campaign_attachment.attachment_name")}
            </th>
            <th id="attachmentTableHeadingColumn2">
              {t("simple_form.labels.attachment.size")}
            </th>
            <th id="attachmentTableHeadingColumn3" />
          </tr>
        </thead>
        <tbody>
          {props.attachments.map((attachment, ind) => {
            let promptDel = (e) => {
              e.preventDefault();
              props.dispatch(
                ceModalRemoveAttachmentShow(attachment.client_attachment_id),
              );
            };
            return (
              <tr key={ind} className="active">
                <td>{attachment.attachment_name}</td>
                <td>{humanReadableSize(attachment.size)}</td>
                <td className="requires-padding">
                  {props.allowEditing && (
                    <a
                      onClick={promptDel}
                      href="#"
                      className="button action-button trash-button"
                    >
                      <i className="ir">{t("buttons.remove")}</i>
                    </a>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {props.loading
        ? attachmentLoadingSpinner
        : props.allowEditing &&
          props.attachments &&
          props.attachments.length > 0 && (
            <div className="pull-left">
              <a
                href="#"
                className="button"
                onClick={(e) => {
                  e.preventDefault();
                  props.dispatch(ceModalUploadAttachmentOpen());
                }}
              >
                {t("buttons.attach_a_file_to_this_campaign")}
              </a>
            </div>
          )}
    </div>
  ) : (
    props.allowEditing &&
      props.attachments &&
      props.attachments.length > 0 &&
      (props.loading ? (
        this._renderAttachmentLoadingSpinner()
      ) : (
        <div className="pull-left">
          <a
            href="#"
            className="button"
            onClick={(e) => {
              e.preventDefault();
              props.dispatch(ceModalUploadAttachmentOpen());
            }}
          >
            {t("buttons.attach_a_file_to_this_campaign")}
          </a>
        </div>
      ))
  );
};

const mapStateToProps = (state) => ({
  attachments: state.data.attachments,
});

export default connect(mapStateToProps)(AttachmentsSection);
